import React from 'react'

import { FieldArray } from 'formik'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import LABEL from '../../../business-const/Label/Label'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    ValidatorFormPadrao,
} from '../../../business-components/Form/Form'

import {
    GridContainer,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    processaRegistrosDefaultIniciaisObjConsorcio,
} from './ConsorcioServiceSimulacao'

import ConsorcioFormSimulacaoItem from './ConsorcioFormSimulacaoItem'



const ConsorcioFormSimulacao = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue, linhaTipoLicenca,
    report, indAtual, pagina }) => {
        
    useSingleton(async () => {

        processaRegistrosDefaultIniciaisObjConsorcio(values)
    })
    

    
    return (
        <DivForm>
            <ValidatorFormPadrao
                onSubmit={handleSubmit}
                onError={
                    () => null
                }
            >
                <FieldArray name="objConsorcio.simulacao">
                    {(arrayHelpers) => (
                        <DivForm>
                            <GridContainer>
                                {values.objConsorcio.simulacao?.map((item, ind) => {

                                    return ((!indAtual && indAtual !== 0) || ind === indAtual) && (
                                        <GridItem12
                                            key={ind}
                                        >
                                            <ConsorcioFormSimulacaoItem
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                item={item}
                                                ind={ind}
                                                handleChange={handleChange}
                                                handleSubmit={handleSubmit}
                                                setFieldValue={setFieldValue}
                                                arrayHelpers={arrayHelpers}
                                                linhaTipoLicenca={linhaTipoLicenca}
                                                report={report}
                                                pagina={pagina}
                                            />
                                        </GridItem12>
                                    )
                                })}
                            </GridContainer>
                            
                            {!report && (
                                <ButtonIncluirLinha
                                    label={LABEL.buttonIncluirSimulacaoConsorcio} 
                                    onClick={() =>
                                        {
                                            arrayHelpers.push({})
                                        }
                                    }
                                />
                            )}
                        </DivForm>
                    )}
                </FieldArray>
            </ValidatorFormPadrao>
        </DivForm>
    )
}

export default ConsorcioFormSimulacao